import script from "./WorkTypeDistribution.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkTypeDistribution.vue?vue&type=script&setup=true&lang=js"

import "./WorkTypeDistribution.vue?vue&type=style&index=0&id=6e759532&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e759532"]])

export default __exports__